export const getHeaderDataTestId = (pageComponentIndex = 0) =>
  `scorecard-${pageComponentIndex}-header`
export const getScoreDataTestId = (index = '0') => `score-container-${index}`
export const getScoreFooterText = (totalAnswered = 0, totalQuestions = 0) =>
  `You've answered ${totalAnswered} out of ${totalQuestions} questions.`
export const getWrapperDataTestId = (pageComponentIndex = 0) =>
  `scorecard-${pageComponentIndex}-wrapper`
